import type { DraftStateUpdater } from 'utils/react/StateProxy';
import type { DeliveryId, WebHooksState } from '../WebHooksState';

export interface DeleteDeliveriesCommand {
  deliveryIdsToDelete: DeliveryId[];
}

export const makeDeleteDeliveries =
  (
    getState: () => WebHooksState,
    updateState: DraftStateUpdater<WebHooksState>,
  ) =>
  ({ deliveryIdsToDelete }: DeleteDeliveriesCommand): void => {
    const { recentDeliveries } = getState();
    if (recentDeliveries) {
      const newDeliveries = recentDeliveries.filter(
        ({ id }) => !deliveryIdsToDelete.includes(id),
      );

      updateState((draft) => {
        draft.recentDeliveries = newDeliveries;
      });
    }
  };
